"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLocalStartOfDayISOString = exports.getUTCStartOfDayISOString = void 0;
const getUTCStartOfDayISOString = (date) => {
    return new Date(Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(), 0, 0, 0, 0)).toISOString();
};
exports.getUTCStartOfDayISOString = getUTCStartOfDayISOString;
const getLocalStartOfDayISOString = (date) => {
    return new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), 0, 0, 0, 0)).toISOString();
};
exports.getLocalStartOfDayISOString = getLocalStartOfDayISOString;
//# sourceMappingURL=convert-date-utc-to-iso-string.js.map